<template>
    <div class="batch-unbind-root">
        <div class="batch-unbind-panel fade-in">
            <MaintCollapsibleBanner
                title="批量解绑学生主卡号"
                icon="el-icon-bank-card"
                storage-key="batchUnbindMainCard"
            >
                <div class="desc-item">
                    <span class="desc-badge badge-primary">解绑范围</span>
                    <span>仅解绑学生<strong>主卡号</strong>，逻辑与人员管理编辑保存（清空卡号）一致；<strong>不解绑备用卡</strong>。</span>
                </div>
                <div class="desc-item">
                    <span class="desc-badge badge-warning">第三方同步</span>
                    <span>钉钉/微信机构会同步清空 <code>MpUser.UserCardNo</code> 与 <code>MpUserAssignAppUser.UserCardNo</code>。</span>
                </div>
                <div class="desc-item">
                    <span class="desc-badge badge-success">使用建议</span>
                    <span>可先选班级后点<strong>解绑本班已绑主卡</strong>（单次请求、服务端自动分批）；或勾选部分学生解绑。每批最多 <strong>50</strong> 人，需超密授权。</span>
                </div>
            </MaintCollapsibleBanner>

            <el-tabs v-model="activeTab" class="main-tabs" @tab-click="onMainTabClick">
                <el-tab-pane label="学生列表" name="students" lazy>
                    <section class="query-layout">
                        <aside class="dept-filter-pane">
                            <div class="dept-filter-header">
                                <i class="el-icon-school"></i>
                                <span>按班级筛选</span>
                            </div>
                            <DepartmentPane directory-scope="teaching" @tree-node-click="onDeptSelect" @collapse-change="onDeptCollapseChange" />
                        </aside>
                        <main class="query-main">
                            <el-card shadow="never" class="step-card branch-card-teal query-filter-card">
                                <div class="toolbar-filter-bar">
                                <el-form :inline="true" size="small" class="toolbar-filter-form">
                                    <div class="toolbar-filter-fields">
                                    <el-form-item label="姓名">
                                        <el-input v-model="query.name" clearable placeholder="支持模糊查询" class="toolbar-field-w-md" />
                                    </el-form-item>
                                    <el-form-item label="卡号">
                                        <el-input v-model="query.cardNo" clearable placeholder="主卡号模糊" class="toolbar-field-w-md" />
                                    </el-form-item>
                                    <el-form-item label="绑定状态">
                                        <el-select v-model="query.bindStatus" clearable placeholder="全部" class="toolbar-field-w-sm">
                                            <el-option label="全部" value="" />
                                            <el-option label="已绑主卡" value="bound" />
                                            <el-option label="无主卡" value="unbound" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" size="small" icon="el-icon-search" :loading="listLoading" @click="doQuery">查询</el-button>
                                    </el-form-item>
                                    </div>
                                </el-form>
                                </div>
                            </el-card>

                            <div v-if="summary" class="stat-inline">
                                <span class="stat-inline-item tone-blue">匹配 <strong>{{ summary.TotalCount }}</strong> 人</span>
                                <span class="stat-inline-item tone-green">已绑主卡 <strong>{{ summary.BoundCount }}</strong> 人</span>
                                <span class="stat-inline-item tone-orange">无主卡 <strong>{{ summary.UnboundCount }}</strong> 人</span>
                            </div>

                            <el-card shadow="never" class="step-card branch-card result-list-card">
                                <div slot="header" class="card-header-styled result-header">
                                    <div class="result-header-left">
                                        <i class="el-icon-tickets"></i>
                                        <span>学生列表</span>
                                        <span class="header-hint">仅「已绑主卡」可勾选，点击行可选中</span>
                                    </div>
                                    <div class="result-header-actions">
                                        <el-button
                                            type="warning"
                                            size="small"
                                            icon="el-icon-office-building"
                                            :loading="unbindDeptLoading"
                                            :disabled="!query.departmentId"
                                            @click="openUnbindDeptDialog"
                                        >解绑本班已绑主卡</el-button>
                                        <el-button
                                            type="danger"
                                            size="small"
                                            icon="el-icon-delete"
                                            :loading="unbindLoading"
                                            :disabled="multipleSelection.length === 0"
                                            @click="openUnbindDialog"
                                        >解绑已选（{{ multipleSelection.length }}）</el-button>
                                    </div>
                                </div>
                                <div class="result-table-host" ref="resultTableHost">
                                    <el-table
                                        ref="resultTable"
                                        :data="list"
                                        row-key="UserId"
                                        v-loading="listLoading"
                                        size="medium"
                                        class="custom-table"
                                        border
                                        :height="resultTableHeight"
                                        @selection-change="handleSelectionChange"
                                        @row-click="onStudentRowClick"
                                        :row-class-name="studentRowClassName"
                                    >
                                        <el-table-column type="selection" width="46" :selectable="rowSelectable" />
                                        <el-table-column prop="UserName" label="姓名" width="100" />
                                        <el-table-column prop="DeptName" label="部门/班级" min-width="120" show-overflow-tooltip />
                                        <el-table-column prop="CardNo" label="主卡号" width="130" show-overflow-tooltip />
                                        <el-table-column prop="StuCode" label="学号" width="120" show-overflow-tooltip />
                                        <el-table-column label="状态" width="100" align="center">
                                            <template slot-scope="scope">
                                                <el-tag size="mini" :type="rowHasMainCard(scope.row) ? 'success' : 'info'" effect="plain">
                                                    {{ rowHasMainCard(scope.row) ? '已绑主卡' : '无主卡' }}
                                                </el-tag>
                                            </template>
                                        </el-table-column>
                                        <template slot="empty">
                                            <div class="table-empty-tip">
                                                <i class="el-icon-info"></i>
                                                暂无数据，请选择班级或输入筛选条件后查询
                                            </div>
                                        </template>
                                    </el-table>
                                </div>
                                <div class="pagination-container result-pagination">
                                    <el-pagination
                                        background
                                        layout="total, prev, pager, next, jumper"
                                        :page-size="query.intPageSize"
                                        :total="total"
                                        :current-page.sync="query.page"
                                        @current-change="onPageChange"
                                    />
                                </div>
                            </el-card>

                            <el-card v-if="executeResult" shadow="never" class="step-card branch-card-orange execute-report-card">
                                <div slot="header" class="card-header-styled result-header">
                                    <div class="result-header-left">
                                        <i class="el-icon-document-checked"></i>
                                        <span>本次解绑执行报告</span>
                                    </div>
                                    <el-button type="text" size="mini" icon="el-icon-close" @click="executeResult = null">关闭</el-button>
                                </div>
                                <div class="report-message-box">
                                    <span class="report-badge badge-live">{{ executeResultBatchLabel }}</span>
                                    <span class="report-text">{{ executeResult.Message }}</span>
                                </div>
                                <el-table :data="executeResult.Items" size="medium" max-height="220" class="custom-table" border>
                                    <el-table-column type="index" label="#" width="50" align="center" />
                                    <el-table-column prop="UserName" label="姓名" width="100" />
                                    <el-table-column prop="DeptName" label="部门/班级" min-width="120" show-overflow-tooltip />
                                    <el-table-column prop="OldCardNo" label="原主卡号" width="130" show-overflow-tooltip />
                                    <el-table-column prop="StatusText" label="状态" width="90" align="center">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" :type="statusTagType(scope.row.Status)" effect="plain">
                                                {{ scope.row.StatusText }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="MpUser同步" width="100" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.MpUserSynced ? '是' : '否' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Msg" label="说明" min-width="160" show-overflow-tooltip />
                                </el-table>
                            </el-card>
                        </main>
                    </section>
                </el-tab-pane>

                <el-tab-pane label="历史执行记录" name="logs" lazy>
                    <section class="logs-layout">
                        <el-card shadow="never" class="step-card branch-card-teal result-list-card">
                            <div slot="header" class="card-header-styled result-header">
                                <div class="result-header-left">
                                    <i class="el-icon-time"></i>
                                    <span>历史执行记录</span>
                                </div>
                                <el-button size="small" icon="el-icon-refresh" :loading="logListLoading" @click="loadLogList">刷新</el-button>
                            </div>
                            <div class="result-table-host result-table-host--log" ref="logTableHost">
                                <el-table :data="logList" ref="logTable" v-loading="logListLoading" size="medium" class="custom-table" border :height="logTableHeight">
                                    <el-table-column prop="StartTime" label="执行时间" width="170" />
                                    <el-table-column prop="TriggerUserName" label="操作人" width="100" />
                                    <el-table-column prop="TotalCount" label="总数" width="70" align="right" />
                                    <el-table-column prop="SuccessCount" label="成功" width="70" align="right" />
                                    <el-table-column prop="SkippedCount" label="跳过" width="70" align="right" />
                                    <el-table-column prop="FailedCount" label="失败" width="70" align="right" />
                                    <el-table-column prop="StatusText" label="批次状态" width="100" align="center" />
                                    <el-table-column prop="Message" label="汇总" min-width="180" show-overflow-tooltip />
                                    <el-table-column label="操作" width="100" align="center" fixed="right">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="mini" @click="showLogDetail(scope.row)">查看明细</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="pagination-container result-pagination">
                                <el-pagination
                                    background
                                    layout="total, prev, pager, next, jumper"
                                    :page-size="logQuery.intPageSize"
                                    :total="logTotal"
                                    :current-page.sync="logQuery.page"
                                    @current-change="onLogPageChange"
                                />
                            </div>
                        </el-card>
                    </section>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog
            :title="unbindDialogTitle"
            :visible.sync="unbindDialogVisible"
            width="480px"
            append-to-body
            :close-on-click-modal="false"
            custom-class="batch-unbind-ops-dialog"
        >
            <el-alert
                type="warning"
                :closable="false"
                show-icon
                title="超级管理员操作"
                :description="unbindDialogAlertDesc"
                style="margin-bottom: 16px"
            />
            <div v-if="unbindBatchHint" class="unbind-batch-hint">
                <i class="el-icon-info"></i> {{ unbindBatchHint }}
            </div>
            <div v-else-if="unbindMode === 'department' && deptBoundCount > 0" class="unbind-batch-hint dept-bound-summary">
                <i class="el-icon-office-building"></i>
                「{{ selectedDeptName }}」共 <strong>{{ deptBoundCount }}</strong> 人已绑主卡，确认后将由服务端自动分批解绑。
            </div>
            <div v-else-if="unbindTargets.length && unbindMode !== 'department'" class="unbind-target-list">
                <div v-for="item in unbindTargets" :key="item.UserId" class="unbind-target-item">
                    <span>{{ item.UserName }}</span>
                    <span class="unbind-target-hint">卡号 {{ item.CardNo || '-' }}</span>
                </div>
            </div>
            <el-form label-width="100px" size="small" style="margin-top: 16px">
                <el-form-item label="超密授权码" required>
                    <el-input
                        v-model="unbindAuthCode"
                        type="password"
                        show-password
                        placeholder="请输入超密授权码"
                        autocomplete="off"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="unbindDialogVisible = false">取消</el-button>
                <el-button type="danger" :loading="unbindLoading" @click="confirmBatchUnbind">确认解绑</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :title="logDetailTitle"
            :visible.sync="logDetailVisible"
            width="820px"
            append-to-body
            custom-class="batch-unbind-ops-dialog"
        >
            <div v-if="logDetailSummary" class="report-message-box" style="margin-bottom: 12px">
                <span class="report-text">{{ logDetailSummary }}</span>
            </div>
            <el-form :inline="true" size="small" class="log-detail-filter">
                <el-form-item label="姓名">
                    <el-input
                        v-model="logDetailQuery.name"
                        clearable
                        placeholder="模糊查询"
                        style="width: 120px"
                        @keyup.enter.native="onLogDetailSearch"
                    />
                </el-form-item>
                <el-form-item label="原主卡号">
                    <el-input
                        v-model="logDetailQuery.cardNo"
                        clearable
                        placeholder="模糊查询"
                        style="width: 130px"
                        @keyup.enter.native="onLogDetailSearch"
                    />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="logDetailQuery.status" clearable placeholder="全部" style="width: 110px">
                        <el-option label="成功" value="success" />
                        <el-option label="跳过" value="skipped" />
                        <el-option label="失败" value="failed" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :loading="logDetailLoading" @click="onLogDetailSearch">查询</el-button>
                    <el-button @click="resetLogDetailFilter">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="logDetailItems" v-loading="logDetailLoading" size="small" border max-height="400">
                <el-table-column label="#" width="50" align="center" :index="logDetailIndexMethod" type="index" />
                <el-table-column prop="UserName" label="姓名" width="100" />
                <el-table-column prop="DeptName" label="部门/班级" min-width="120" show-overflow-tooltip />
                <el-table-column prop="OldCardNo" label="原主卡号" width="130" />
                <el-table-column prop="StatusText" label="状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="statusTagType(scope.row.Status)" effect="plain">{{ scope.row.StatusText }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="MpUser" width="80" align="center">
                    <template slot-scope="scope">{{ scope.row.MpUserSynced ? '是' : '否' }}</template>
                </el-table-column>
                <el-table-column prop="Msg" label="说明" min-width="140" show-overflow-tooltip />
            </el-table>
            <el-pagination
                v-if="logDetailTotal > 0"
                layout="total, prev, pager, next"
                :page-size="logDetailQuery.intPageSize"
                :total="logDetailTotal"
                :current-page="logDetailQuery.page"
                style="margin-top: 12px; text-align: right"
                @current-change="onLogDetailPageChange"
            />
        </el-dialog>
    </div>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane';
import MaintCollapsibleBanner from '../components/MaintCollapsibleBanner';
import { studentCardOpsGetList, studentCardOpsExecuteBatchUnbind, studentCardOpsGetBatchLogList, studentCardOpsGetBatchLogDetail } from '../../../api/modules/personnel';
import { studentCardOpsExecuteBatchUnbindByDepartment } from '../../../api/modules/department';

/** 单次接口调用最多解绑人数 */
const MAX_UNBIND_PER_REQUEST = 50;
/** 按班级拉取已绑主卡时的最大扫描人数 */
const MAX_DEPT_BOUND_SCAN = 2000;

/**
 * 学生主卡号批量解绑运维模块。创建于 2026-06-16
 */
export default {
    name: 'BatchUnbindMainCard',
    components: { DepartmentPane, MaintCollapsibleBanner },
    data() {
        return {
            query: {
                page: 1,
                name: '',
                cardNo: '',
                departmentId: '',
                bindStatus: '',
                intPageSize: 10
            },
            selectedDeptName: '',
            list: [],
            total: 0,
            summary: null,
            listLoading: false,
            unbindLoading: false,
            unbindDeptLoading: false,
            multipleSelection: [],
            unbindDialogVisible: false,
            unbindMode: 'selection',
            deptBoundCount: 0,
            unbindAuthCode: '',
            unbindTargets: [],
            executeResult: null,
            logQuery: { page: 1, intPageSize: 10 },
            logList: [],
            logTotal: 0,
            logListLoading: false,
            logDetailVisible: false,
            logDetailTitle: '执行明细',
            logDetailSummary: '',
            logDetailItems: [],
            logDetailQuery: { batchLogId: 0, page: 1, intPageSize: 10, name: '', cardNo: '', status: '' },
            logDetailTotal: 0,
            logDetailLoading: false,
            activeTab: 'students',
            resultTableHeight: 420,
            logTableHeight: 420
        };
    },
    computed: {
        unbindDialogTitle() {
            if (this.unbindMode === 'department') {
                return `解绑本班已绑主卡 — ${this.selectedDeptName || '当前部门'}`;
            }
            return '批量解绑主卡号确认';
        },
        unbindDialogAlertDesc() {
            return '将清空所选学生主卡号并释放卡库占用，操作不可撤销。';
        },
        unbindBatchHint() {
            if (this.unbindMode === 'department') {
                const batchCount = Math.ceil(this.deptBoundCount / MAX_UNBIND_PER_REQUEST);
                if (batchCount <= 1) return '';
                return `共 ${this.deptBoundCount} 人，服务端将自动分 ${batchCount} 批执行（每批最多 ${MAX_UNBIND_PER_REQUEST} 人）`;
            }
            const count = this.unbindTargets.length;
            if (count <= MAX_UNBIND_PER_REQUEST) return '';
            const batchCount = Math.ceil(count / MAX_UNBIND_PER_REQUEST);
            return `共 ${count} 人，将自动分 ${batchCount} 批执行（每批最多 ${MAX_UNBIND_PER_REQUEST} 人）`;
        },
        executeResultBatchLabel() {
            if (!this.executeResult) return '';
            const ids = this.executeResult.BatchLogIds;
            if (ids && ids.length > 1) {
                return `已写入 ${ids.length} 批日志`;
            }
            const id = this.executeResult.BatchLogId || (ids && ids[0]);
            return id ? `已写入日志 #${id}` : '已写入日志';
        }
    },
    mounted() {
        this.loadLogList();
        this.scheduleTableHeightSync();
        window.addEventListener('resize', this.scheduleTableHeightSync);
        this.$nextTick(() => this.bindTableHostObserver());
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.scheduleTableHeightSync);
        this.unbindTableHostObserver();
        if (this._tableHeightTimer) {
            clearTimeout(this._tableHeightTimer);
            this._tableHeightTimer = null;
        }
    },
    methods: {
        /** 按宿主容器实测高度同步 el-table，保证表体内滚。最后更新：2026-09-09 */
        scheduleTableHeightSync() {
            if (this._tableHeightTimer) clearTimeout(this._tableHeightTimer);
            this._tableHeightTimer = setTimeout(() => {
                this.syncTableHeights();
            }, 50);
        },
        bindTableHostObserver() {
            if (typeof ResizeObserver === 'undefined') return;
            this.unbindTableHostObserver();
            this._tableHostObserver = new ResizeObserver(() => {
                this.scheduleTableHeightSync();
            });
            const resultHost = this.$refs.resultTableHost;
            if (resultHost) this._tableHostObserver.observe(resultHost);
            const logHost = this.$refs.logTableHost;
            if (logHost) this._tableHostObserver.observe(logHost);
        },
        unbindTableHostObserver() {
            if (this._tableHostObserver) {
                this._tableHostObserver.disconnect();
                this._tableHostObserver = null;
            }
        },
        /** 优先用宿主高度；宿主过小时按视口剩余高度兜底。创建于 2026-09-09 */
        resolveHostTableHeight(host, paginationSelector) {
            if (!host) return 0;
            const hostHeight = host.clientHeight;
            if (hostHeight >= 160) return hostHeight;

            const cardBody = host.parentElement;
            if (cardBody && cardBody.clientHeight > 0) {
                let reserved = 12;
                Array.prototype.forEach.call(cardBody.children, (child) => {
                    if (child === host) return;
                    reserved += child.offsetHeight || 0;
                });
                const bodyAvailable = cardBody.clientHeight - reserved;
                if (bodyAvailable >= 160) return bodyAvailable;
            }

            const pagination = paginationSelector
                ? this.$el.querySelector(paginationSelector)
                : null;
            const pagH = pagination ? pagination.offsetHeight : 48;
            const top = host.getBoundingClientRect().top;
            return Math.max(280, Math.floor(window.innerHeight - top - pagH - 28));
        },
        syncTableHeights() {
            this.$nextTick(() => {
                const resultHost = this.$refs.resultTableHost;
                if (resultHost) {
                    const nextHeight = this.resolveHostTableHeight(resultHost, '.result-pagination');
                    if (nextHeight > 0) this.resultTableHeight = nextHeight;
                }
                const logHost = this.$refs.logTableHost;
                if (logHost) {
                    const nextLogHeight = this.resolveHostTableHeight(logHost, '.result-pagination');
                    if (nextLogHeight > 0) this.logTableHeight = nextLogHeight;
                }
                const resultTable = this.$refs.resultTable;
                if (resultTable && resultTable.doLayout) resultTable.doLayout();
                const logTable = this.$refs.logTable;
                if (logTable && logTable.doLayout) logTable.doLayout();
            });
        },
        onMainTabClick(tab) {
            if (tab.name === 'logs') {
                this.loadLogList();
            }
            this.$nextTick(() => {
                this.bindTableHostObserver();
                this.scheduleTableHeightSync();
                setTimeout(() => this.scheduleTableHeightSync(), 200);
            });
        },
        /** 部门树折叠/展开后重算表格高度。创建于 2026-09-09 */
        onDeptCollapseChange() {
            this.scheduleTableHeightSync();
            setTimeout(() => this.scheduleTableHeightSync(), 280);
        },
        chunkArray(arr, size) {
            const chunks = [];
            for (let i = 0; i < arr.length; i += size) {
                chunks.push(arr.slice(i, i + size));
            }
            return chunks;
        },
        onDeptSelect(data) {
            this.query.departmentId = data.value;
            this.selectedDeptName = data.label;
            this.query.page = 1;
            this.doQuery();
        },
        onPageChange(page) {
            this.query.page = page;
            this.doQuery();
        },
        onLogPageChange(page) {
            this.logQuery.page = page;
            this.loadLogList();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val || [];
        },
        /** 列表行归一化，兼容 PascalCase / camelCase，UserId 转字符串避免雪花 ID 精度丢失。最后修改：2026-06-16 */
        normalizeListRow(row) {
            if (!row) return row;
            const userId = row.UserId != null ? row.UserId : row.userId;
            const cardNo = row.CardNo != null ? row.CardNo : (row.cardNo || '');
            const hasMainCard = row.HasMainCard === true
                || row.hasMainCard === true
                || String(cardNo || '').trim().length > 0;
            return {
                UserId: userId != null ? String(userId) : '',
                UserName: row.UserName || row.userName || '',
                DeptName: row.DeptName || row.deptName || '',
                CardNo: cardNo || '',
                StuCode: row.StuCode || row.stuCode || '',
                HasMainCard: hasMainCard
            };
        },
        /** 是否已绑主卡（可选行） */
        rowHasMainCard(row) {
            if (!row) return false;
            if (row.HasMainCard === true) return true;
            const cardNo = row.CardNo || '';
            return String(cardNo).trim().length > 0;
        },
        rowSelectable(row) {
            return this.rowHasMainCard(row);
        },
        /** 点击行切换勾选（跳过复选框列与不可选行） */
        onStudentRowClick(row, column, event) {
            if (!this.rowHasMainCard(row)) return;
            if (column && column.type === 'selection') return;
            if (event && event.target && event.target.closest('.el-checkbox')) return;
            this.$refs.resultTable.toggleRowSelection(row);
        },
        studentRowClassName({ row }) {
            return this.rowHasMainCard(row) ? 'row-selectable' : 'row-not-selectable';
        },
        statusTagType(status) {
            if (status === 'success') return 'success';
            if (status === 'skipped') return 'info';
            if (status === 'failed') return 'danger';
            return 'info';
        },
        doQuery() {
            this.listLoading = true;
            studentCardOpsGetList(this.query).then(res => {
                this.listLoading = false;
                if (res.data && res.data.success) {
                    const response = res.data.response || {};
                    const rawList = response.Data || response.data || [];
                    this.list = rawList.map(item => this.normalizeListRow(item));
                    this.total = response.DataCount || response.dataCount || 0;
                    this.summary = response.Summary || response.summary || null;
                    this.multipleSelection = [];
                    this.$nextTick(() => {
                        if (this.$refs.resultTable) {
                            this.$refs.resultTable.clearSelection();
                        }
                        this.scheduleTableHeightSync();
                    });
                } else {
                    this.$message.error((res.data && res.data.msg) || '查询失败');
                }
            }).catch(() => {
                this.listLoading = false;
            });
        },
        openUnbindDialog() {
            if (this.multipleSelection.length === 0) {
                this.$message.error('请勾选已绑主卡的学生');
                return;
            }
            this.unbindMode = 'selection';
            this.unbindTargets = this.multipleSelection.slice();
            this.unbindAuthCode = '';
            this.unbindDialogVisible = true;
        },
        openUnbindDeptDialog() {
            if (!this.query.departmentId) {
                this.$message.warning('请先在左侧选择班级或部门');
                return;
            }
            this.unbindDeptLoading = true;
            studentCardOpsGetList({
                page: 1,
                intPageSize: 1,
                departmentId: this.query.departmentId,
                bindStatus: 'bound',
                name: '',
                cardNo: ''
            }).then(res => {
                this.unbindDeptLoading = false;
                if (!res.data || !res.data.success) {
                    this.$message.error((res.data && res.data.msg) || '查询本班已绑学生失败');
                    return;
                }
                const response = res.data.response || {};
                const boundCount = response.DataCount || 0;
                if (boundCount === 0) {
                    this.$message.info(`「${this.selectedDeptName}」下暂无已绑主卡学生`);
                    return;
                }
                if (boundCount > MAX_DEPT_BOUND_SCAN) {
                    this.$message.error(`本部门已绑人数超过 ${MAX_DEPT_BOUND_SCAN}，请选中更下级班级后重试`);
                    return;
                }
                this.unbindMode = 'department';
                this.deptBoundCount = boundCount;
                this.unbindTargets = [];
                this.unbindAuthCode = '';
                this.unbindDialogVisible = true;
            }).catch(() => {
                this.unbindDeptLoading = false;
            });
        },
        applyExecuteResult(response) {
            const merged = {
                BatchLogId: response.BatchLogId ? String(response.BatchLogId) : '',
                BatchLogIds: response.BatchLogIds || (response.BatchLogId ? [response.BatchLogId] : []),
                TotalCount: response.TotalCount || 0,
                SuccessCount: response.SuccessCount || 0,
                SkippedCount: response.SkippedCount || 0,
                FailedCount: response.FailedCount || 0,
                Items: response.Items || [],
                Message: response.Message || ''
            };
            if (!merged.BatchLogId && merged.BatchLogIds.length) {
                merged.BatchLogId = merged.BatchLogIds.length === 1
                    ? String(merged.BatchLogIds[0])
                    : merged.BatchLogIds.join(', ');
            }
            this.executeResult = merged;
            this.unbindDialogVisible = false;
            this.multipleSelection = [];
            this.deptBoundCount = 0;
            if (this.$refs.resultTable) this.$refs.resultTable.clearSelection();
            this.$message.success(merged.Message || '解绑完成');
            this.doQuery();
            this.loadLogList();
            this.$nextTick(() => this.scheduleTableHeightSync());
        },
        async confirmBatchUnbind() {
            if (!this.unbindAuthCode) {
                this.$message.error('请输入超密授权码');
                return;
            }
            this.unbindLoading = true;
            try {
                if (this.unbindMode === 'department') {
                    const res = await studentCardOpsExecuteBatchUnbindByDepartment({
                        departmentId: this.query.departmentId,
                        departmentName: this.selectedDeptName,
                        authCode: this.unbindAuthCode
                    });
                    this.unbindLoading = false;
                    if (res.data && res.data.success) {
                        this.applyExecuteResult(res.data.response || {});
                    } else {
                        this.$message.error((res.data && res.data.msg) || '按部门解绑失败');
                    }
                    return;
                }

                if (this.unbindTargets.length === 0) {
                    this.$message.error('未选择解绑人员');
                    this.unbindLoading = false;
                    return;
                }
                const userIds = this.unbindTargets.map(x => x.UserId);
                const chunks = this.chunkArray(userIds, MAX_UNBIND_PER_REQUEST);
                const merged = {
                    BatchLogId: '',
                    BatchLogIds: [],
                    TotalCount: userIds.length,
                    SuccessCount: 0,
                    SkippedCount: 0,
                    FailedCount: 0,
                    Items: [],
                    Message: ''
                };
                let stopped = false;
                for (let i = 0; i < chunks.length; i++) {
                    const res = await studentCardOpsExecuteBatchUnbind({
                        userIds: chunks[i],
                        authCode: this.unbindAuthCode
                    });
                    if (!res.data || !res.data.success) {
                        this.$message.error((res.data && res.data.msg) || `第 ${i + 1} 批解绑失败`);
                        stopped = true;
                        break;
                    }
                    const batchResult = res.data.response || {};
                    const logIds = batchResult.BatchLogIds && batchResult.BatchLogIds.length
                        ? batchResult.BatchLogIds
                        : (batchResult.BatchLogId ? [batchResult.BatchLogId] : []);
                    merged.BatchLogIds = merged.BatchLogIds.concat(logIds);
                    merged.SuccessCount += batchResult.SuccessCount || 0;
                    merged.SkippedCount += batchResult.SkippedCount || 0;
                    merged.FailedCount += batchResult.FailedCount || 0;
                    merged.Items = merged.Items.concat(batchResult.Items || []);
                }
                merged.BatchLogId = merged.BatchLogIds.length === 1
                    ? String(merged.BatchLogIds[0])
                    : merged.BatchLogIds.join(', ');
                const batchPart = chunks.length > 1 ? `共 ${chunks.length} 批：` : '';
                merged.Message = `${batchPart}成功 ${merged.SuccessCount} 人，跳过 ${merged.SkippedCount} 人，失败 ${merged.FailedCount} 人`;
                this.unbindLoading = false;
                if (stopped && merged.SuccessCount === 0) {
                    return;
                }
                this.applyExecuteResult(merged);
                if (stopped) {
                    this.$message.warning('部分批次已完成，请查看执行报告');
                }
            } catch (e) {
                this.unbindLoading = false;
                this.$message.error('解绑请求异常');
            }
        },
        loadLogList() {
            this.logListLoading = true;
            studentCardOpsGetBatchLogList(this.logQuery).then(res => {
                this.logListLoading = false;
                if (res.data && res.data.success) {
                    const response = res.data.response || {};
                    this.logList = response.Data || [];
                    this.logTotal = response.DataCount || 0;
                    this.scheduleTableHeightSync();
                }
            }).catch(() => {
                this.logListLoading = false;
            });
        },
        showLogDetail(row) {
            this.logDetailTitle = `执行明细 #${row.Id}`;
            this.logDetailSummary = row.Message || '';
            this.logDetailQuery.batchLogId = row.Id;
            this.logDetailQuery.page = 1;
            this.logDetailQuery.name = '';
            this.logDetailQuery.cardNo = '';
            this.logDetailQuery.status = '';
            this.logDetailVisible = true;
            this.loadLogDetail();
        },
        onLogDetailSearch() {
            this.logDetailQuery.page = 1;
            this.loadLogDetail();
        },
        resetLogDetailFilter() {
            this.logDetailQuery.name = '';
            this.logDetailQuery.cardNo = '';
            this.logDetailQuery.status = '';
            this.logDetailQuery.page = 1;
            this.loadLogDetail();
        },
        onLogDetailPageChange(page) {
            this.logDetailQuery.page = page;
            this.loadLogDetail();
        },
        logDetailIndexMethod(index) {
            return (this.logDetailQuery.page - 1) * this.logDetailQuery.intPageSize + index + 1;
        },
        loadLogDetail() {
            if (!this.logDetailQuery.batchLogId) return;
            this.logDetailLoading = true;
            studentCardOpsGetBatchLogDetail(this.logDetailQuery).then(res => {
                this.logDetailLoading = false;
                if (res.data && res.data.success) {
                    const response = res.data.response || {};
                    this.logDetailItems = response.Items || response.items || [];
                    this.logDetailTotal = response.DataCount || response.dataCount || 0;
                    if (response.Log && response.Log.Message) {
                        this.logDetailSummary = response.Log.Message;
                    } else if (response.log && response.log.Message) {
                        this.logDetailSummary = response.log.Message;
                    }
                } else {
                    this.$message.error((res.data && res.data.msg) || '加载明细失败');
                }
            }).catch(() => {
                this.logDetailLoading = false;
            });
        }
    }
};
</script>

<style scoped>
.batch-unbind-root {
    flex: 1 1 0;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.batch-unbind-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.main-tabs {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.main-tabs >>> .el-tabs__header {
    flex-shrink: 0;
    margin: 0 0 6px !important;
}

.main-tabs >>> .el-tabs__nav-wrap::after {
    height: 1px;
}

.main-tabs >>> .el-tabs__item {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: 600;
    padding: 0 18px !important;
}

.main-tabs >>> .el-tabs__item.is-active {
    font-weight: 700;
}

.main-tabs >>> .el-tabs__content {
    flex: 1;
    min-height: 0;
    height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.main-tabs >>> .el-tab-pane {
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.logs-layout {
    flex: 1;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 4px 8px;
}

.logs-layout > .result-list-card {
    flex: 1 1 0% !important;
    height: 0 !important;
    min-height: 0 !important;
    margin-bottom: 0 !important;
}

.fade-in {
    animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}

.query-layout {
    flex: 1 1 0;
    min-height: 0;
    height: 0;
    display: flex;
    align-items: stretch;
    gap: 12px;
    overflow: hidden;
}

/* 左侧部门树：对齐全局 .dp-left（264px）；折叠时宽度归零仅留展开浮钮。最后更新：2026-09-09 */
.dept-filter-pane {
    position: relative;
    flex: 0 0 264px;
    width: 264px;
    min-width: 264px;
    max-width: 264px;
    flex-shrink: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    border-left: 4px solid #6366f1;
    overflow: hidden;
    box-sizing: border-box;
    transition: all 0.25s ease;
}

.dept-filter-pane.is-collapsed {
    flex: 0 0 0 !important;
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    padding: 0 !important;
    border: none !important;
    margin: 0 !important;
    overflow: visible !important;
    box-shadow: none !important;
    background: transparent !important;
}

.dept-filter-pane.is-collapsed .dept-filter-header {
    display: none !important;
}

.dept-filter-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
    border-bottom: 1px solid #f1f5f9;
    flex-shrink: 0;
}

.dept-filter-header i { color: #6366f1; }

.dept-filter-pane ::v-deep .department-pane {
    flex: 1;
    height: auto;
    min-height: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.dept-filter-pane.is-collapsed ::v-deep .department-pane {
    overflow: visible !important;
}

/* 与同步页统一：深层级节点允许换行，避免班级名被截成省略号。最后更新：2026-09-09 */
.dept-filter-pane ::v-deep .department-pane .el-tree {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #94a3b8 #f1f5f9;
}

.dept-filter-pane ::v-deep .department-pane .el-tree-node__content {
    height: auto;
    min-height: 32px;
    padding-top: 4px;
    padding-bottom: 4px;
}

.dept-filter-pane ::v-deep .tree-node__label {
    white-space: normal;
    word-break: break-all;
    line-height: 1.4;
}

.query-main {
    flex: 1;
    min-width: 0;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-right: 4px;
}

.step-card {
    border-radius: 6px !important;
    border: 1px solid #e2e8f0;
    margin-bottom: 6px;
    flex-shrink: 0;
}

.step-card ::v-deep .el-card__header {
    padding: 6px 10px;
    min-height: auto;
    border-bottom: 1px solid #f1f5f9;
}

.step-card ::v-deep .el-card__body {
    padding: 6px 10px !important;
}

.query-filter-card {
    flex: 0 0 auto;
}

.query-filter-card ::v-deep .el-card__body {
    padding: 4px 8px !important;
}

.query-filter-card ::v-deep .el-form-item {
    margin-bottom: 0;
}

.query-filter-card ::v-deep .el-form-item__label {
    padding-bottom: 0;
    line-height: 32px;
}

/* 列表卡必须吃满 query-main 剩余高度，否则表格会被卡死在内容高度。最后更新：2026-09-09 */
.query-main > .result-list-card,
.result-list-card {
    flex: 1 1 0% !important;
    flex-shrink: 1 !important;
    height: 0 !important;
    min-height: 0 !important;
    margin-bottom: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    box-sizing: border-box;
}

.result-list-card ::v-deep .el-card__header {
    flex: 0 0 auto;
    padding: 6px 10px;
}

.result-list-card ::v-deep .el-card__body {
    flex: 1 1 0% !important;
    height: 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 4px 8px 6px !important;
    box-sizing: border-box;
    overflow: hidden !important;
}

.result-list-card .selection-hint {
    display: none;
}

.result-table-host {
    flex: 1 1 0% !important;
    min-height: 0 !important;
    height: 0 !important;
    overflow: hidden;
    position: relative;
}

.result-table-host--log {
    min-height: 0;
}

.execute-report-card {
    flex: 0 0 auto;
    max-height: 280px;
    overflow: auto;
    margin-top: 8px;
    margin-bottom: 0 !important;
}

.result-table-host ::v-deep .el-table {
    width: 100%;
}

.result-table-host ::v-deep .el-table__body-wrapper {
    overflow-y: auto !important;
    overflow-x: auto !important;
}

.table-empty-tip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #94a3b8;
    font-size: 13px;
    line-height: 1.5;
    padding: 4px 0;
}

.table-empty-tip i {
    color: #94a3b8;
}

.result-list-card ::v-deep .pagination-container,
.result-list-card .result-pagination {
    flex: 0 0 auto !important;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    width: 100%;
    margin-top: 8px !important;
    margin-bottom: 0 !important;
    padding: 4px 0 0 !important;
    min-height: 40px;
}

.branch-card { border-left: 4px solid #6366f1 !important; }
.branch-card-teal { border-left: 4px solid #0d9488 !important; }
.branch-card-orange { border-left: 4px solid #f59e0b !important; }

.card-header-styled {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
}

.card-header-styled i { color: #6366f1; }

.result-header {
    justify-content: space-between;
}

.result-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.header-hint {
    font-size: 12px;
    font-weight: 400;
    color: #94a3b8;
    margin-left: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.result-header-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.selection-hint {
    display: none;
}

.selection-hint i {
    display: none;
}

::v-deep .custom-table .row-selectable {
    cursor: pointer;
}

::v-deep .custom-table .row-not-selectable {
    cursor: default;
}

.unbind-batch-hint {
    font-size: 13px;
    color: #d97706;
    margin-bottom: 12px;
    padding: 8px 12px;
    background: rgba(217, 119, 6, 0.08);
    border-radius: 6px;
    border: 1px solid rgba(217, 119, 6, 0.2);
}

.dept-bound-summary {
    color: #0d9488;
    background: rgba(13, 148, 136, 0.08);
    border-color: rgba(13, 148, 136, 0.2);
}

.stat-inline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 14px;
    margin-bottom: 6px;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    flex: 0 0 auto;
}

.stat-inline-item {
    font-size: 13px;
    color: #64748b;
    line-height: 1.4;
}

.stat-inline-item strong {
    font-size: 14px;
    font-weight: 700;
    margin: 0 2px;
    color: #1e293b;
}

.stat-inline-item.tone-blue strong { color: #2563eb; }
.stat-inline-item.tone-green strong { color: #059669; }
.stat-inline-item.tone-orange strong { color: #d97706; }

.stat-dashboard,
.stat-card {
    display: none;
}

.report-message-box {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #f8fafc;
    border-radius: 8px;
    margin-bottom: 16px;
    border: 1px solid #e2e8f0;
}

.report-badge {
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
}

.badge-live {
    background: rgba(16, 185, 129, 0.12);
    color: #059669;
    border: 1px solid rgba(16, 185, 129, 0.25);
}

.report-text { font-size: 13px; color: #475569; }

.unbind-target-list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
}

.unbind-target-item {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 13px;
    border-bottom: 1px dashed #f1f5f9;
}

.unbind-target-item:last-child { border-bottom: none; }
.unbind-target-hint { color: #64748b; font-size: 12px; }

.log-detail-filter {
    margin-bottom: 12px;
}

.log-detail-filter ::v-deep .el-form-item {
    margin-bottom: 0;
}
</style>
